<div>
  <ng-container *ngIf="asset">
    <div class="image-container">
      <div *ngIf="showLoader" class="spinner-container">
        <mat-spinner [diameter]="50"></mat-spinner>
      </div>
      <img [src]="imagePath" [ngClass]="{'force-contain': forceContain === true}" (load)="onImageLoaded($event)">
    </div>
    <div class="asset-name">
      <span>{{asset.name}}</span>
    </div>
  </ng-container>
  <div *ngIf="showButtons" class="bottom-buttons">
    <button *ngIf="assetType === 'npc'" mat-raised-button color="primary" (click)="onNewNpcClick()">
      <mat-icon fontSet="fa" fontIcon="fa-plus-circle"></mat-icon>
      NEW AVATAR
    </button>
    <button mat-stroked-button color="primary" (click)="onOpenFileManager()">
      <mat-icon fontSet="fa" fontIcon="fa-pen"></mat-icon>
      CHOOSE FROM LIBRARY
    </button>
  </div>
</div>
